import { siteMap } from "internal-sitemap";
import React from "react";
import { Redirect } from "react-router";
import useCultureCodeRoute from "utilities/hooks/routing/use-culture-code-route";
import useFeatureFlags from "utilities/hooks/use-feature-flags";
import { RouteDefinition } from "utilities/interfaces/route-definition";
import { RouteUtils } from "utilities/route-utils";
import {
    NestedRoutes,
    NestedRoutesProps,
} from "utilities/routing/nested-route";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface BookmarksAndCollectionsLayoutProps extends NestedRoutesProps {}
export const CSS_CLASS_NAME = "c-bookmarks-and-collections-layout";

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const BookmarksAndCollectionsLayout: React.FC<any> = (
    props: BookmarksAndCollectionsLayoutProps
) => {
    const { generateCultureCodedRoute } = useCultureCodeRoute();
    const { useMyLiNKRedesign } = useFeatureFlags();

    if (!useMyLiNKRedesign) {
        // Redirect to old MyLiNK Bookmarks if user somehow stumbles upon a new route
        return (
            <Redirect
                to={generateCultureCodedRoute(
                    siteMap.myLink.myBookmarks.dashboard
                )}
            />
        );
    }

    return (
        <>
            <NestedRoutes
                routes={props.routes.map((route: RouteDefinition) =>
                    RouteUtils.withCulture<RouteDefinition>(route)
                )}
            />
        </>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default BookmarksAndCollectionsLayout;

// #endregion Exports
